export default "__VITE_ASSET__BbO7Q1Sq__"